import * as actionTypes from './actionTypes';
import constants from "../../utils/constants";

const log = require("loglevel").getLogger("programReducer");
log.setLevel("debug");

const initialState = JSON.stringify({
	programs: null,
	lastUpdated: null
});

function programReducer(state = JSON.parse(initialState), action) {
	switch (action.type) {
		case constants.GLOBAL_ACTION_INIT_STATE: {
			log.debug("reset program state");
			return initialState;
		}
		case actionTypes.PROGRAM_LOADED: {
			const loadedProgram = action.data;
			let {programs} = state;
			const index = (programs || []).findIndex(p => p.Id === loadedProgram.Id);

			if(index > -1) {
				programs[index] = loadedProgram;
			}
			else {
				programs = [loadedProgram];
			}

			return {
				...state,
				programs
			};
		}
		case actionTypes.PROGRAMS_LOADED: {
			return {
				...state,
				programs: action.data,
				lastUpdated: action.lastUpdated
			};
		}
		default:
			return state;
	}
}

export default programReducer;
